import { useState } from 'react'
import { IAutocompleteBaseOption } from 'transfix-ui/components/AutocompleteBase'
import { TQuoteFilters } from '../../../types'

interface IUseShipperProps {
  quotesFilters: TQuoteFilters
  setQuotesFilters: React.Dispatch<React.SetStateAction<TQuoteFilters>>
}

type TBaseValue = Pick<IAutocompleteBaseOption, 'id' | 'text'>

export const useShipper = ({ quotesFilters, setQuotesFilters }: IUseShipperProps) => {
  const initialShipper = quotesFilters.shipperApplicationId
    ? {
        id: quotesFilters.shipperApplicationId || '',
        text:
          quotesFilters.shipperApplicationName || `Shipper #${quotesFilters.shipperApplicationId}`,
      }
    : null
  const [shipper, setShipper] = useState<TBaseValue | null>(initialShipper)

  const selectShipperHandler = (newVal: TBaseValue | null) => {
    setShipper(newVal)
    setQuotesFilters({
      ...quotesFilters,
      shipperApplicationId: newVal?.id,
      shipperApplicationName: newVal?.text,
    })
  }

  const clearShipperHandler = () => {
    setShipper(null)
    const updatedQuotes = { ...quotesFilters }
    delete updatedQuotes.shipperApplicationId
    setQuotesFilters({ ...updatedQuotes })
  }

  return { selectShipperHandler, clearShipperHandler, shipper }
}
